import { ref } from 'vue';
// 如果需要实现浏览器的后退监控并自定义弹窗，可采用popstate事件监听实现，具体兼容需要测试.
export function usePageLeave () {
  const showBack = ref(false);
  // const pushHistory = () => {
  //   const state = {
  //     title: document.title,
  //     url: document.URL
  //   };
  //   window.history.pushState(state, state.title, state.url);
  // };
  // const listener = () => {
  //   showBack.value = true;
  //   pushHistory();
  // };
  // onMounted(() => {
  //   pushHistory(); 
  //   window.addEventListener('popstate', listener);
  // });
  // onUnmounted(() => {
  //   window.removeEventListener('popstate', listener);
  // });
  return {
    showBack
  };
}